import React, { useEffect } from "react";

const queryString = window.location.search;
const params = new URLSearchParams(queryString);

const paramDebug = params.get("debug");
export const Logger = {
  debug(...args) {
    if (queryString === "?debug=1") {
      console.log(...args);
    } else {
      console.log = () => {};
    }
  },

  info(...args) {
    if (queryString === "?debug=1" || queryString === "?info=1") {
      console.info(...args);
    } else {
      console.info = () => {};
    }
  },

  error(...args) {
    if (
      queryString === "?debug=1" ||
      queryString === "?info=1" ||
      queryString === "?error=1"
    ) {
      console.error(...args);
    } else {
      console.error = () => {};
    }
  },
};
